export var BusinessRFIActorType;
(function (BusinessRFIActorType) {
    BusinessRFIActorType["Admin"] = "ADMIN";
    BusinessRFIActorType["Business"] = "BUSINESS";
    /**
     * A payment rail, not a person. Used on the note that opens an RFI because a
     * processor parked a transaction pending information: attributing that to
     * Admin would put a machine action under a human's name, and would send the
     * admin audit log looking up a user id that is really a processor name.
     */
    BusinessRFIActorType["Processor"] = "PROCESSOR";
})(BusinessRFIActorType || (BusinessRFIActorType = {}));
//# sourceMappingURL=BusinessRFIActorType.js.map